export default {
  SHOW_INFO: function (state, infos) {
    state.infos = [...infos];
  },
  HIDE_INFO: function (state, value) {
    state.infos = [];
  },
};
